import {
  IPayoutSettingsResponse,
  PayoutDestinationType
} from "@wingspanhq/payments/dist/interfaces";
import { IMember } from "@wingspanhq/users/dist/lib/interfaces";
import { components } from "../../services/api/onboarding/types";
import { selectorDefaultDestination } from "./selectorDefaultDestination";

export const selectorUseInternationalInstantPayouts = (
  member: IMember,
  monitoredEntity?: components["schemas"]["CustomerEntity"],
  payoutSettings?: IPayoutSettingsResponse
) => {
  const defaultDestination = payoutSettings
    ? selectorDefaultDestination(payoutSettings)
    : undefined;

  if (
    defaultDestination?.destinationType ===
    ("InternalAccount" as PayoutDestinationType)
  ) {
    return true;
  }

  if (monitoredEntity && monitoredEntity.type === "Business") {
    return monitoredEntity.country === "CA";
  }

  return member.profile.address?.country === "CA";
};
